import React, { useMemo } from "react";

import bannerBtcImage from "../../assets/images/banner-btc.png";    
import bannerEthImage from "../../assets/images/banner-eth.png";
import bannerTslaImage from "../../assets/images/banner-tsla.png";

const BANNERS = [bannerBtcImage, bannerEthImage, bannerTslaImage];

const Banner = ({ href = "https://www.trilfi.com", className = "", seed}) => {
  const src = useMemo(() => BANNERS[Math.floor(Math.random() * BANNERS.length)],[seed]);

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={`block overflow-hidden border border-[#2A2A2A] transition-all ease-in-out hover:opacity-90 ${className}`}
    >
    <img src={src} alt="banner" loading="lazy" className="block h-auto w-full object-cover"/>
    </a>
  );
};

export default Banner;